import { QueryKey } from '@/configs/queryKeys';
import { Attachment, BaseEntity, UUID } from '@/types/types';
import { Order } from './OrderApi';
import { UserType } from '@/types/user';
import EntityApi from './EntityApi';
import httpClient from './httpClient';

export enum ComplaintStatus {
	NEW = 'new',
	IN_PROGRESS = 'in_progress',
	ACCEPTED = 'accepted',
	REJECTED = 'rejected',
}

export interface Sender {
	email: string;
	id: UUID;
	userType: UserType;
}

export interface ComplaintMessage extends BaseEntity {
	text: string;
	sender: Sender;
	attachments: Attachment[];
}

export interface Complaint extends BaseEntity {
	number: string;
	order: Order;
	status: ComplaintStatus;
	description: string;
	attachments: Attachment[];
	messages: ComplaintMessage[];
}

class ComplaintApi extends EntityApi<Complaint> {
	constructor() {
		super(QueryKey.complaints);
		this.addMessage = this.addMessage.bind(this);
	}

	async addMessage({ complaintId, text }: { complaintId: UUID; text: string }) {
		const response = await httpClient.post<ComplaintMessage>(
			`${this.queryKey}/${complaintId}/messages`,
			{ text }
		);
		return response.data;
	}
}

export default new ComplaintApi();
